export const TAILWIND_BROWSER_SCRIPT = '<script src="https://unpkg.com/@tailwindcss/browser@4"></script>';

// A full-viewport page stays pinned to 100dvh, so it gets no height reporting: the parent would
// otherwise resize it to its content and break vh units, fixed elements and anchors inside it
export function embedHeightScripts(fullViewport: boolean, embedId?: string) {
  if (fullViewport) return { head: '', tail: '' };

  const messageTarget = embedId ? `embedId: ${JSON.stringify(embedId)}` : 'url: window.location.href';

  return {
    head: `
      <script>
        function beehiiv_sendHeight(reason) {
          return function () {
            const height = document.body.scrollHeight;
            parent.postMessage({ type: "beehiiv:iframe_height", height, reason, ${messageTarget} }, "*");
          }
        }

        document.addEventListener("DOMContentLoaded", beehiiv_sendHeight("DOMContentLoaded"));
        window.addEventListener("resize", beehiiv_sendHeight("resize"));
        document.addEventListener("input", beehiiv_sendHeight("input"));
        document.addEventListener("change", beehiiv_sendHeight("change"));
      </script>`,
    tail: `
  <script>
    const observer = new MutationObserver(beehiiv_sendHeight("MutationObserver"));
    try {
      observer.observe(document.body, { childList: true, subtree: true });
    }
    catch (e) {
      console.error(e)
    }
  </script>`,
  };
}
